
window.initLabels = function (item){
    let list = item.querySelector('.labels__list');
    let groupWidth = item.offsetWidth;
    let listWidth = list.offsetWidth;

    if(groupWidth < listWidth){
        list.style.animationPlayState = 'running';
        let clone = list.cloneNode(true);
        list.after(clone)
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.labels').forEach(window.initLabels)
})
